import { Link } from "office-ui-fabric-react";
import React from "react";
import { AddRegular, DocumentAddRegular } from "@fluentui/react-icons";
import { SweetAlerts } from "../UtilityFunctions/SweetAlerts";
import NewContract from "./NewContract";

function RequestAI(props) {
  const [attachmentData, setAttachmentData] = React.useState([]);
  const [AiAttachment, setAiAttachment] = React.useState({});
  const [isRequestOpen, setIsRequestOpen] = React.useState(false);
  const { SweetAlert: SweetalertsRequest, SweetPrompt: SweetPromptRequestAI } = SweetAlerts("#SweetalertsRequestAI");

  React.useEffect(() => {
    // Office.onReady(() => {
    // var outlookItem = Office.context.mailbox.item;

    // if (outlookItem && outlookItem.getAttachmentsAsync) {
    //   outlookItem.getAttachmentsAsync(function (result) {
    //     if (result.status === Office.AsyncResultStatus.Succeeded) {
    //       if (result.value.length > 0) {
    //         console.log("Attachments Found:", result.value);
    //         const attachments = [];

    //         result.value.forEach((attachment:any) => {
    //             if(attachment?.contentType=="application/pdf"||attachment?.contentType=="application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    //           attachments.push({
    //             ...attachment,
    //             isSelected: false,
    //           });
    //           setAttachmentData(attachments);
    //           console.log("Attachment Name:", attachment.name);
    //           console.log("Attachment ID:", attachment.id);
    //         });
    //       } else {
    //         console.log("No attachments found.");
    //       }
    //     } else {
    //       console.error("Failed to fetch attachments:", result.error.message);
    //     }
    //   });
    // } else {
    //   console.log("getAttachmentsAsync is not supported in this context.");
    // }
    var outlookItem = Office.context.mailbox.item;

if (outlookItem && outlookItem.getAttachmentsAsync) {
  outlookItem.getAttachmentsAsync(function (result) {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      if (result.value.length > 0) {
        // console.log("Attachments Found:", result.value);
        const attachments = [];
        const allowFile=["application/pdf","application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
        const filteredAttachments= result.value?.filter((ele:any)=>allowFile?.includes(ele.contentType || getContentType(ele?.name)))
        processAttachments(filteredAttachments,outlookItem)
      } else {
        console.log("No attachments found.");
      }
    } else {
      console.error("Failed to fetch attachments:", result.error.message);
    }
  });
} else {
  console.log("getAttachmentsAsync is not supported in this context.");
}

  }, []);

  function getContentType(fileName) {
  const ext = fileName?.split('.')?.pop()?.toLowerCase();

  const type= {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    txt: "text/plain"
  };

  return type[ext] ?? '';
}

  const processAttachments = async (filteredAttachments,outlookItem) => {
    const attachments = [];

    if (!filteredAttachments || filteredAttachments.length === 0) {
        console.log("No valid attachments found.");
        return;
    }

    const attachmentPromises: Promise<void>[] = filteredAttachments.map(
      (attachment: any) =>
          new Promise<void>((resolve, reject) => {
              outlookItem.getAttachmentContentAsync(attachment.id, function (contentResult) {
                  if (contentResult.status === Office.AsyncResultStatus.Succeeded) {
                      const fileContent = contentResult.value.content;

                      const byteCharacters = atob(fileContent);
                      const byteArrays = [];
                      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                          const slice = byteCharacters.slice(offset, offset + 1024);
                          const byteNumbers = new Array(slice.length);
                          for (let i = 0; i < slice.length; i++) {
                              byteNumbers[i] = slice.charCodeAt(i);
                          }
                          byteArrays.push(new Uint8Array(byteNumbers));
                      }

                      const blob = new Blob(byteArrays, { type: attachment.contentType });
                      const file = new File([blob], attachment.name, { type: attachment.contentType });
                      const fileExtension = attachment.name?.split(".").pop(); // Get the file extension
                      const fileName = attachment.name?.split(".")[0]?.replaceAll("_", " "); // Process file name
                      
                      const formattedFileName = fileExtension === "pdf" || fileExtension === "docx"
                        ? `${fileName}.${fileExtension}`
                        : fileName; // Ensures only .docx or .pdf gets appended
                      
                      attachments.push({
                          file: file,
                          isSelected: false,
                          name: attachment.name,
                          contentType: attachment.contentType,
                          size: attachment.size,
                          key: formattedFileName,
                          text: formattedFileName,
                          value: formattedFileName,
                          label: formattedFileName,
                          ServerRelativeUrl: attachment?.ServerRelativeUrl,
                          Attachment:file,
                      });

                      console.log("Added file to attachments:", file);
                      resolve(); 
                  } else {
                      console.error("Failed to fetch attachment content:", contentResult.error.message);
                      reject(contentResult.error);
                  }
              });
          })
  );

  await Promise.all(attachmentPromises);

    setAttachmentData(attachments);
    // console.log("All files added to attachments state:", attachments);
};
  // React.useEffect(() => {
  //   console.log(attachmentData, "Attachment Length");
  //   if (attachmentData?.length == 1) {
  //     setAiAttachment(attachmentData[0]);
  //     setIsRequestOpen(true);
  //   }
  // }, [attachmentData]);

  const setAttachmentsAI = (attachment) => {
    SweetPromptRequestAI("warning", "Are you sure you want to use this file?").then((c) => {
      if (c?.isConfirmed) {
        setAiAttachment(attachment);
        setIsRequestOpen(true);
      }
    });
  };

  return (
    <div id="SweetalertsRequestAI">
      {/* {!isRequestOpen && (
        <>
          {attachmentData?.length > 1 ? (
            <div>
              Please select any one file
              <div className="outlookAttachments">
                {attachmentData?.map((attachment, index) => {
                  return (
                    <div className={"Attatchemntdiv"} title={attachment?.name} key={index}>
                      <span className={"Attatcmenticons"} style={{ margin: "0px 5px" }}>
                        <DocumentAddRegular />
                      </span>

                      <span className={"Attatchmentext1"}>
                        <a
                          style={{ textDecoration: "none", color: "black" }}
                          href={attachment.ServerRelativeUrl}
                          target="_blank"
                          download={attachment?.name}
                        >
                          {attachment?.name}
                        </a>
                      </span>

                      <Link
                        style={{ marginLeft: "auto", paddingRight: "5px" }}
                        onClick={() => {
                          setAttachmentsAI(attachment);
                        }}
                      >
                        <AddRegular style={{ marginLeft: "auto", cursor: "pointer" }} />
                      </Link>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : attachmentData?.length == 0 ? (
            <div style={{ textAlign: "center" }}>No attachments available</div>
          ) : null}
        </>
      )} */}

      {/* {isRequestOpen ? ( */}
        <NewContract
          isNewContract={props?.isNewContract}
          setisNewContract={props?.setisNewContract}
          allContracts={props?.allContracts}
          tokenvalue={props?.tokenvalue}
          siteURL={props?.siteURL}
          currentUser={props?.currentUser}
          setisOpenRequest={props?.setisOpenRequest}
          currentUserID={props?.currentUserID}
          SettingsListData={props?.SettingsListData}
          attachmentData={attachmentData}
          isFromAI={true}
          setCreateRequestAI={props?.setCreateRequestAI}
        />
      {/* ) : null} */}
    </div>
  );
}

export default RequestAI;
